<template>
    <div class="form-group row">
    <!-- <div class="row" style="width:100%"> -->
        <div class="form-group col-md-4" style="margin-bottom:.50rem">
            <label >Cognome</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Cognome" v-model="persona.COGNOME">
        </div> 
        <div class="form-group col-md-4" style="margin-bottom:.50rem">
            <label>Nome</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Nome" v-model="persona.NOME">
        </div>
        <div class="form-group col-md-2" style="margin-bottom:.50rem">
            <label>Sesso</label>
            <select class="form-control form-control-sm" v-model="persona.SESSO">
                <option value="1">MASCHIO</option>
                <option value="2">FEMMINA</option>
            </select>
        </div>  
        <div class="form-group col-md-2" style="margin-bottom:.50rem">
            <label>Data nascita</label>
            <DatePicker v-model="persona.DATA_NASCITA" :dim="'sm'"></DatePicker>
        </div>        
    <!-- </div> -->
        <div class="form-group col-md-3" style="margin-bottom:.50rem">
            <label>Luogo di nascita</label>
            <Select2  v-model="persona.FK_ID_COMUNE_NASCITA" :w="189" :api="'core/geo/comuni/select2'" @onSelectItem="calcolaCodiceFiscale($event)" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'"></Select2>
        </div>
        <div class="form-group col-md-3" style="margin-bottom:.50rem">
            <label>Codice Fiscale</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Codice fiscale" v-model="persona.CODICE_FISCALE">
        </div>   
        <div class="form-group col-md-3" style="margin-bottom:.50rem">
            <label>Email</label>
            <input autocomplete="off" type="text" class="form-control  form-control-sm" placeholder="Email" v-model="persona.EMAIL">
        </div>
        <div class="form-group col-md-3" style="margin-bottom:.50rem">
            <label>Telefono</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Telefono" v-model="persona.TELEFONO">
        </div>   
        <div class="form-group col-md-6" style="margin-bottom:.50rem">
            <label>Indirizzo</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Indirizzo" v-model="persona.INDIRIZZO">
        </div>  
        <div class="form-group col-md-4" style="margin-bottom:.50rem">
            <label>Comune</label>
            <Select2 @onSelectItem="setCap($event)" v-model="persona.FK_ID_COMUNE" :w="250" :api="'core/geo/comuni/select2'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'"></Select2>
        </div>
        <div class="form-group col-md-2" style="margin-bottom:.50rem">
            <label>Cap</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Cap" v-model="persona.CAP">
        </div> 
        <div class="form-group col-md-4" style="margin-bottom:.50rem">
            <label>È un utente dell'Università</label>
            <select class="form-control form-control-sm" v-model="persona.FK_ID_ENTE">
                <option value="1">SI</option>
                <option value="0">NO</option>
            </select>
        </div> 

        <div class="form-group col-md-3" style="margin-bottom:.50rem">
            <label>Tipo documento</label>
            <select class="form-control form-control-sm" v-model="persona.TIPO_DOCUMENTO">
                <option value="1">CARTA IDENTITÀ</option>
                <option value="2">PATENTE</option>
                <option value="3">PASSAPORTO</option>
            </select>
        </div> 

        <div class="form-group col-md-3" style="margin-bottom:.50rem">
            <label>Numero documento</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Numero documento" v-model="persona.NUMERO_DOCUMENTO">
        </div> 

        <div class="form-group col-md-2" style="margin-bottom:.50rem">
            <label>Data scadenza doc</label>
            <DatePicker v-model="persona.DATA_SCADENZA_DOCUMENTO" :dim="'sm'"></DatePicker>
        </div> 
        
        <div class="form-group col-md-2" style="margin-bottom:.50rem">
            <label>ABBREVIAZIONE</label>
            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="ABBREVIAZIONE" v-model="persona.ABBREVIAZIONE">
        </div> 

        <div class="form-group col-md-12" v-show="persona.ID_PERSONA_FISICA > 0" style="margin-bottom:.50rem;margin-top:40px">
            <label class="h2">Documento di identità <button v-on:click="openAllegato()" v-show="persona.URL_DOCUMENTO != ''" class="btn btn-primary btn-grid">Scarica documento</button></label>
            <Upload @onsuccess="successCaricamento($event)" :orientamento="'o'" :w="90" :args="argsUpload"></Upload>
        </div>
        


    
</div>
</template>
<script>

import { computed } from 'vue'
import Select2 from '@/components/utils/Select2.vue'
import DatePicker from '@/components/utils/DatePicker.vue'
import Upload from '@/components/utils/Upload.vue'



export default {
    name: 'PersonaFisica',
    components:{
        Select2,
        DatePicker,
        Upload
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
        },
        co:{
            type:Array,
        }
    },
    emits: ['update:modelValue',"ricarica"],
    setup(props, { emit }) {
        const persona = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });
        return { persona };
    },
    data:function(){
        return{
           
        }
    },
    methods: {
        setCap(item){
            console.log("SET CAP");
            if (this.persona.CAP == "" || (this.persona.CAP != item.CAP && item.CAP.indexOf("x") == -1)){
                this.persona.CAP = item.CAP;                
            }       
        },
        calcolaCodiceFiscale : function(comune){
            console.log(comune);
            var date = moment(this.persona.DATA_NASCITA,"DD/MM/YYYY",true);
            if (this.persona.SESSO > 0 && this.persona.COGNOME != "" && this.persona.NOME != "" && date.isValid() && this.persona.FK_ID_COMUNE_NASCITA > 0 && comune.ID_COMUNE != 8094){
                date = new Date(date._d);
                //giorno,mese,anno,cognome,nome,sesso,comune
                var codiceFiscale = utils.calcolaCodiceFiscale(date.getDate(),date.getMonth() + 1,date.getFullYear(),this.persona.COGNOME,this.persona.NOME,this.persona.SESSO,comune.COD_FISCO);
                codiceFiscale = codiceFiscale.toUpperCase();
                if (codiceFiscale != this.persona.CODICE_FISCALE){
                    this.persona.CODICE_FISCALE = codiceFiscale;
                    utils.alert.info("Codice fiscale calcolato automaticamente");
                }
            }
        },
        isCampoObbligatorio(idOpzione){
            if (this.co != undefined){
                var r = utils.array.select(this.co,"FK_ID_OPZIONE",idOpzione,1)[0];
                if (r != undefined){
                    return r['VALORE'];
                }                
            }
            return 0;
        },
        successCaricamento : function(res){
            if (res.esito == 0){
                utils.alert.success("Operazione correttamente eseguita");
                this.$emit("ricarica",this.persona.ID_PERSONA_FISICA);
            }
        },
        openAllegato : function(){
            window.open(global.utils.BASE_API + "core/report?ID_REPORT=1002&ID_PERSONA_FISICA="+this.persona.ID_PERSONA_FISICA+"&SESSION_TOKEN="+utils.SESSION_TOKEN);
        },
    },
    computed: {
        argsUpload : function(){
            return   {modalita:'EMMET_uploadDocPf',ID_PERSONA_FISICA:this.persona.ID_PERSONA_FISICA}
        }
    },
    watch: {
        
    },
}

</script>